import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminContact() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/contact-messages").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const del = async (it) => {
        if (!confirm("Nachricht löschen?")) return;
        await api.delete(`/admin/contact-messages/${it.id}`);
        toast.success("Gelöscht");
        load();
    };

    return (
        <div className="p-6 md:p-10 max-w-5xl">
            <div className="text-[11px] font-bold uppercase tracking-widest text-brand-green">Posteingang</div>
            <h1 className="mt-1 font-display text-3xl font-bold">Kontakt-Nachrichten</h1>

            <div className="mt-6 grid gap-3">
                {items.map((it) => (
                    <div key={it.id} className="card-clean p-5">
                        <div className="flex items-start justify-between gap-4 flex-wrap">
                            <div>
                                <div className="font-semibold">{it.name} <span className="text-brand-charcoal/50 font-normal">— {it.email}</span></div>
                                {it.subject && <div className="text-xs text-brand-charcoal/60 mt-0.5">Betreff: {it.subject}</div>}
                                <p className="mt-3 text-sm text-brand-charcoal/80 whitespace-pre-line">{it.message}</p>
                            </div>
                            <div className="flex flex-col items-end gap-2">
                                <div className="text-xs text-brand-charcoal/50">{new Date(it.created_at).toLocaleString()}</div>
                                <a href={`mailto:${it.email}`} className="btn-outline-dark text-xs py-2"><Mail className="h-3.5 w-3.5" /> Antworten</a>
                                <button onClick={() => del(it)} className="text-xs text-brand-red font-semibold inline-flex items-center gap-1.5"><Trash2 className="h-3.5 w-3.5" /> Löschen</button>
                            </div>
                        </div>
                    </div>
                ))}
                {items.length === 0 && <div className="card-clean p-10 text-center text-sm text-brand-charcoal/60">Keine Nachrichten.</div>}
            </div>
        </div>
    );
}
